import { type Registry as Services, service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import getChartColor from 'frontend-utils/utils/hotel-chart-color';
import {
  SUBTYPE_VALUES_KEY_CANCELLATION_POLICY,
  SUBTYPE_VALUES_KEY_STRATEGY,
  TYPE_ID_MEALTYPE,
  TYPE_ID_POS,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTooltipsEvolutionChartTooltipSignature {
  Args: {
    data: unknown;
    entity: unknown;
    hoveredHotels: unknown;
    type: unknown;
    week: unknown;
  };
}

export default class HotelStrategyTooltipsEvolutionChartTooltip extends Component<HotelStrategyTooltipsEvolutionChartTooltipSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  @service declare intl: Services['intl'];
  @service declare rsSelections: Services['rs-selections'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get data() {
    return this.args.data;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get entity() {
    return this.args.entity;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hoveredHotels() {
    return this.args.hoveredHotels;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get referencePeriodCancellationPolicySection() {
    return this.rsSelections?.referencePeriodCancellationPolicySection;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipRows() {
    // @ts-expect-error: Incorrect type
    if (!this.data.length) {
      return [];
    }

    let rows = [];

    // @ts-expect-error: Incorrect type
    if (this.entity === SUBTYPE_VALUES_KEY_STRATEGY && this.data.length) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      rows = this.data
        // @ts-expect-error: Incorrect type
        .map((data) => {
          const mappedValues = {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            value: data.formattedValue,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            roomName:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              data.baserateWithFallback?.formattedRoomname ??
              this.intl.t('general.missing'),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            formattedRate:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              data.baserateWithFallback?.formattedBaseRate ??
              this.intl.t('general.missing'),

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            rateTypeIcons: data.baserateWithFallback
              ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                data.baserateWithFallback.rateTypeIcons
              : null,
            backgroundColor: htmlSafe(
              `background-color: ${getChartColor(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                data.hotelinfo.id,
                this.hotelAndMarketService.primaryAndSecondaryCompetitors,
              )}`,
            ),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            hotelName: data.hotelinfo.name,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            isOwnHotel: data.isOwnHotel,
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            isHoveredHotel: this.hoveredHotels.includes(data.hotelinfo.id),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            isSoldOut: data.isSoldOut,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            supplementOrDiscount: data.supplementOrDiscount,
          };

          return mappedValues;
        })
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .sort((strategyA, strategyB) => {
          if (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            strategyA.isSoldOut ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            strategyA.value === this.intl.t('general.missing')
          ) {
            return 1;
          }
          if (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            strategyB.isSoldOut ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            strategyB.value === this.intl.t('general.missing')
          ) {
            return -1;
          }

          return (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            strategyB.supplementOrDiscount - strategyA.supplementOrDiscount
          );
        });
    }

    if (
      this.entity === SUBTYPE_VALUES_KEY_CANCELLATION_POLICY &&
      // @ts-expect-error: Incorrect type
      this.data.length
    ) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      rows = this.data
        // @ts-expect-error: Incorrect type
        .map((data) => {
          const mappedValues = {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            roomName:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              data.baserateWithFallback?.formattedRoomname ??
              this.intl.t('general.missing'),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            formattedRate:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              data.baserateWithFallback?.formattedBaseRate ??
              this.intl.t('general.missing'),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            rateTypeIcons: data.baserateWithFallback?.rateTypeIcons,
            backgroundColor: htmlSafe(
              `background-color: ${getChartColor(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                data.hotelinfo.id,
                this.hotelAndMarketService.primaryAndSecondaryCompetitors,
              )}`,
            ),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            hotelName: data.hotelinfo.name,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            value: data.hasNoData
              ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                data.formattedValue
              : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                `${data.formattedValue}, ${data.time}`,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            isOwnHotel: data.isOwnHotel,
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            isHoveredHotel: this.hoveredHotels.includes(data.hotelinfo.id),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            hasNoData: data.hasNoData,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            days: data.days,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            time: data.time,
          };

          return mappedValues;
        })
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .sort((cancellationPolicyA, cancellationPolicyB) => {
          if (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            cancellationPolicyA.hasNoData ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            cancellationPolicyA.value === this.intl.t('general.missing')
          ) {
            return 1;
          }
          if (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            cancellationPolicyB.hasNoData ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            cancellationPolicyB.value === this.intl.t('general.missing')
          ) {
            return -1;
          }

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (cancellationPolicyA.days === cancellationPolicyB.days) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (cancellationPolicyA.time && cancellationPolicyB.time) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
              const timeNumberA = cancellationPolicyA.time.split(':')[0];
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
              const timeNumberB = cancellationPolicyB.time.split(':')[0];

              // Time should be sorted in descending order
              // https://otainsight.slack.com/archives/G01BUCJAFCN/p1645184313844719?thread_ts=1633075719.014900&cid=G01BUCJAFCNx
              return timeNumberB - timeNumberA;
            }

            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (cancellationPolicyA.time) {
              return 1;
            }

            return -1;
          }

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          return cancellationPolicyB.days - cancellationPolicyA.days;
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipTableSubtitle() {
    if (this.entity === SUBTYPE_VALUES_KEY_CANCELLATION_POLICY) {
      return this.intl.t('strategy.metric_block.cutoff_policy');
    }

    if (this.type === TYPE_ID_MEALTYPE) {
      return this.intl.t('strategy.mealtype.supplement');
    }

    if (this.type === TYPE_ID_POS) {
      return this.intl.t('general.difference');
    }

    return this.intl.t('strategy.metric_block.discount');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get type() {
    return this.args.type;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get week() {
    return this.args.week;
  }

  <template>
    <PrismTooltipHeader>
      <span class="flex items-center">
        {{! @glint-expect-error: Incorrect type }}
        {{t "general.week_of" date=this.week}}
      </span>
    </PrismTooltipHeader>
    <div class="evolution-chart-tooltip__content">
      <table cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <td class="text-200--bold">
              {{t "rates.hotelname"}}
            </td>
            <td class="text-200--bold">
              {{t "rates.rate"}}
            </td>
            <th class="rate-icons"></th>
            <td class="text-200--bold">
              {{t "general.room_name"}}
            </td>
            <td class="text-200--bold">
              {{this.tooltipTableSubtitle}}
            </td>
          </tr>
        </thead>
        <tbody class="text-200--regular">
          {{#each this.tooltipRows as |rowData|}}
            <tr
              class="{{if rowData.isOwnHotel 'highlight'}}
                {{if rowData.isHoveredHotel 'hovered'}}"
            >
              <td class="hotel-name">
                <div class="flex flex-row items-center">
                  <div
                    class="identifier-bullet"
                    style={{rowData.backgroundColor}}
                  ></div>
                  <p>{{rowData.hotelName}}</p>
                </div>
              </td>
              <td class="competitor-rate">
                <div class="flex justify-start">
                  {{rowData.formattedRate}}

                </div>
              </td>
              <td class="rate-icons">
                {{#each rowData.rateTypeIcons as |icon|}}
                  {{#if icon}}
                    <div class="rate-icons__prism-icon">
                      <PrismIcon @name={{icon}} @size="extra-small" />
                    </div>
                  {{/if}}
                {{/each}}
              </td>
              <td class="room-name">
                {{rowData.roomName}}
              </td>
              <td>
                {{rowData.value}}
              </td>
            </tr>
          {{/each}}
        </tbody>
      </table>
    </div>
  </template>
}
